export default "__VITE_ASSET__BeaNrun5__"